// Copy for the trader dashboard (DashboardBuyer.jsx) that has to be pinned by a
// test. The dashboard's own text is inline `isAr ? … : …` expressions; a string
// whose exact wording is a commitment to the trader lives here instead, where
// dashboardBuyerStrings.test.js can hold it still. Same pattern as
// publicRfqStrings.js beside PublicRfqQuote.jsx.

// The payout-assurance line, shown at the top of the requests section.
// `lead + ' ' + rest` is the owner's exact sentence (2026-09-24), split only so
// the lead can be styled. Reword it HERE, never at the render site.
//
// ⚠️ OPERATOR RULE, NOT A SYSTEM GATE. It is true because the team does not
// transfer money to a supplier it has not reviewed and approved — nothing in
// the code blocks a transfer (docs/TECH_DEBT.md, "Payout is not gated in
// code"). NEVER add "on site" / «ميدانياً» / 实地: nothing records a site visit,
// and the test fails on that wording.
export const PAYOUT_ASSURANCE = {
  ar: {
    lead: 'لا تقلق',
    rest: '— لن يستقبل أي مورّد أموالاً ولن يُحوّل له قبل مراجعته واعتماده من فريق مَعبر.',
  },
  en: {
    lead: 'Rest assured',
    rest: '— no supplier receives or is transferred any funds before our team reviews and approves them.',
  },
  zh: {
    lead: '请放心',
    rest: '— 任何供应商在经过 Maabar 团队审核批准之前，都不会收到或被划转任何款项。',
  },
};

export const payoutAssurance = (lang) => PAYOUT_ASSURANCE[lang] || PAYOUT_ASSURANCE.ar;
